/**
 * Correspondance statut de heat → variante de badge.
 *
 * Fonction pure, sortie de `pages/Heats.tsx` pour que les vues du planning
 * l'utilisent sans dépendre de la page. Le LIBELLÉ, lui, reste dans les
 * composants : il passe par `t()` (les statuts étaient en français en dur
 * jusqu'à la revue du 2026-08-03).
 */
export type HeatStatusVariant =
  | 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' | 'info';

export const getStatusVariant = (status: string): HeatStatusVariant => {
  switch (status) {
    case 'finished':
    case 'completed': return 'success';
    case 'running':
    case 'in_progress': return 'warning';
    case 'countdown': return 'warning';
    case 'preparing': return 'info';
    case 'rest': return 'info';
    case 'cancelled': return 'destructive';
    default: return 'secondary';
  }
};
